<template>
	<div class="qualityenterprise">
		<leftnav class="fl" mkcode="J" :itemcode="pagecode"></leftnav>
		<div class="index_left" :style="isCollapse?'margin-left: 0;width:100%':''">
			<govheader></govheader>
			<div class="index_left_centerpage">
				<div class="heightVh95 whitebox container-flex-center">
					<freeUserTips :type="4" :bgtype="0"></freeUserTips>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { mapState, mapMutations, mapGetters } from "vuex";
	import freeUserTips from "@/components/enterpriseInc/free-user-tips.vue"

	export default {
		name: 'index',
		computed: {
		...mapState({
		// isCollapse: (state) => state.app.isCollapse,
		isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
		},
		data() {
			return {
				curWebsite: this.$api.getWebsiteType(),
				pagecode: 'J-BSXZTZFX', 
			}
		},
		components: {
		 freeUserTips
		}, 
		//监听路由变化、newVal：目标路由，oldVal:原路由，路由不同时重新请求数据
		watch: {
			$route: function(newVal, oldVal) { 
				console.log('watch router investanalysis');  
			this.resetPage();
			}
		},
		beforeCreate() {},
		created() {
			this.$nextTick(() => {
				// 禁用右键
				document.oncontextmenu = new Function("event.returnValue=false");
				// 禁用选择
				document.onselectstart = new Function("event.returnValue=false");
			});
			this.sreachType = this.$route.query.type;
		},
		mounted() {
			this.resetPage();
			document.title = this.sreachType == 1?'本省新增投资分析':'本市新增投资分析';
		},
		methods: {			
			//切换本省本市时清空所有已选数据 所有同个页面多个连接的都需要 
			resetPage(){
				this.sreachType = this.$route.query.type ? this.$route.query.type : 1;
				this.pagecode = this.sreachType == 1 ? 'J-BSXZTZFX' : 'J-BS-XZTZFX';
			}, 
		 
		}
	}
</script>

<style lang="scss">
	.orderField {
		display: block;
		width: 100%;
		height: 100%;

	}
</style>